/* eslint-disable no-invalid-this */
import { find, indexOf } from 'lodash';
import * as Yup from 'yup';

export const pageSchema = Yup.object({
  name: Yup.string()
    .required('Insira um nome')
    .required('O nome é obrigatório'),
  prices: Yup.array().test(
    'at-least-one-price-and-evento',
    'Adicione pelo menos um horário de funcionamento com categoria "Evento"',
    (prices) =>
      Array.isArray(prices) &&
      prices.length > 0 &&
      prices.some((p) => p.vehicleCategory === 'Evento'),
  ),
  operationPeriods: Yup.array().min(1, 'Pelo menos 1').required('required'),
});

export const priceSchema = Yup.object({
  vehicleCategory: Yup.string().required('Selecione uma categoria'),
  timePeriod: Yup.string().required('Selecione um período'),
  price: Yup.string().required('Insira um preço'),
});

export const operationPeriodSchema = Yup.object({
  startTime: Yup.string().required('Selecione um horário inicial'),
  endTime: Yup.string().required('Selecione um horário final'),
});
